import React from "react";
export const GreenCheckIcon = (color) => (React.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { id: "Vector 379", d: "M1 4.54574L4.62265 8.33268L11 1.66607", stroke: color, strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" })));
